import { AwsRum, type AwsRumConfig } from 'aws-rum-web';
import { detectarPlataforma } from '@/lib/plataforma';

let rumInstance: AwsRum | null = null;

export const setRumClient = (client: AwsRum | null): void => {
  rumInstance = client;
};

export const getRumClient = (): AwsRum | null => {
  return rumInstance;
};

/**
 * Inicializa o cliente CloudWatch RUM isolado de cookies (#378).
 * allowCookies começa sempre como false por padrão (LGPD art. 7º I).
 * Se o consentimento local prévio tiver medição = true, ativa allowCookies(true).
 */
export const initRum = (): AwsRum | null => {
  if (rumInstance) {
    return rumInstance;
  }
  const monitorId = import.meta.env.VITE_RUM_APP_MONITOR_ID;
  if (!monitorId) {
    return null;
  }

  try {
    const plataforma = detectarPlataforma();
    const rumRegion = import.meta.env.VITE_AWS_REGION || 'us-east-1';

    const rumConfig: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId: import.meta.env.VITE_RUM_IDENTITY_POOL_ID,
      allowCookies: false,
      enableXRay: false,
      telemetries: ['errors', 'performance'],
      endpoint: `https://dataplane.rum.${rumRegion}.amazonaws.com`,
      sessionAttributes: { plataforma },
    };

    rumInstance = new AwsRum(
      monitorId,
      import.meta.env.VITE_APP_VERSION || '1.0.0',
      rumRegion,
      rumConfig
    );

    // Se usuário já consentiu previamente com medição, ativa cookies
    try {
      const localConsent = localStorage.getItem('ERPLIGHT_COOKIE_CONSENT');
      if (localConsent) {
        const parsed = JSON.parse(localConsent);
        if (parsed?.categorias?.medicao === true) {
          rumInstance.allowCookies(true);
        }
      }
    } catch {
      // Ignora erro de acesso ao localStorage (e.g. storage bloqueado)
    }

    return rumInstance;
  } catch (error) {
    console.error('Falha ao inicializar CloudWatch RUM:', error);
    return null;
  }
};

/**
 * Atualiza dinamicamente o consentimento de cookies para o CloudWatch RUM (#378).
 * Se Medição for aceita: rum.allowCookies(true).
 * Se Medição for recusada/revogada: rum.allowCookies(false) e rum.clearCookies().
 */
export const atualizarCookiesRum = (permitido: boolean): void => {
  if (!rumInstance) {
    return;
  }
  try {
    if (permitido) {
      rumInstance.allowCookies(true);
    } else {
      rumInstance.allowCookies(false);
      rumInstance.clearCookies();
    }
  } catch (error) {
    console.warn('Erro ao atualizar cookies do CloudWatch RUM:', error);
  }
};
